module.exports = __webpack_public_path__ + "static/img/profile-icon11.bd464e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon11.png
// module id = 2959
// module chunks = 1